export const getLeftIndentionForDefaultNavItems = (
   indentationLevel: number
): string => {
   switch (indentationLevel) {
      case 0:
         return 'pl-[12px]'
      case 1:
         return 'pl-[44px]'
      case 2:
         return 'pl-[48px]'

      default:
         return ''
   }
}

export const getLeftIndentionForSectionNavItems = (
   indentationLevel: number
): string => {
   switch (indentationLevel) {
      case 0:
         return 'pl-[8px] navbar-indentation-0'
      case 1:
         return 'pl-[28px] navbar-indentation-1'
      case 2:
         return 'pl-[48px] navbar-indentation-2'
      case 3:
         return 'pl-[68px] navbar-indentation-3'

      default:
         return ''
   }
}
